// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"a25b75e9","697":"9de119ae"}[chunkId] + ".chunk.css";
};